import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {FirmwareGetSchema} from '../../../../api/DBSchema/Firmware';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {dateToString} from '../../../../utils/utils';

const pageSchema = FirmwareGetSchema.pages.general;
const pageId = pageSchema.pageId;

function FirmwareGeneral({
    firmwareObject,
    setFirmwareData,
}) {
    const { t } = useTranslation();

    const pageData = firmwareObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setFirmwareData([pageId, paramName], value);
    }, [setFirmwareData]);

    const appliance       = pageData[pageSchema.type];
    const type          = pageData[pageSchema.privateFirmware];
    const description   = pageData[pageSchema.description];
    const clientVersion = pageData[pageSchema.clientVersion];
    const whatsNew      = pageData[pageSchema.whatsNew];
    const releaseDate   = pageData[pageSchema.releaseDate];
    const enabled       = pageData[pageSchema.enabled];
    
    return (
        <EditorLayout>
               <SMCTextInput
                readOnly
                value={appliance}
                label={t('SMP.SETTINGS.FIRMWARE.APPLIANCE')}
            />
            <SMCTextInput
                readOnly
                value={type ? t('SMC_FIRMWARE_TYPE_PRIVATE_DESCRIPTION') : t('SMC_FIRMWARE_TYPE_PUBLIC_DESCRIPTION')}
                label={t('SMP.TYPE')}
            />
            <SMCTextInput
                readOnly
                value={description}
                label={t('SMC_FIRM_COMMENT')}
            />
            <SMCTextInput
                readOnly
                value={clientVersion}
                label={t('SMC_FIRM_VERSION')}
            />
            <SMCTextInput
                readOnly
                value={whatsNew}
                label={t('SMC_FIRM_WHATS_NEW')}
            />
            <SMCTextInput
                readOnly
                value={dateToString(releaseDate)}
                label={t('SMC_FIRM_RELEASE_DATE')}
            />
            <SMCCheckbox
                checked={enabled}
                onChange={e => setPageValue(pageSchema.enabled, e.target.checked)}
                label={t('SMP.ENABLED')}
            />

        </EditorLayout>
    )
}

export default FirmwareGeneral;